import React, { useEffect, useState, useCallback, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { listarNotificacoes, marcarNotificacaoLida, marcarTodasNotificacoesLidas } from "../services/api";

export default function NotificationBell() {
  const navigate = useNavigate();
  const [itens, setItens] = useState([]);
  const [aberto, setAberto] = useState(false);
  const caixa = useRef(null);

  // 18/10/2026 (Nelson): clicar fora do popup (ou Esc) fecha — antes só fechava clicando no sino de novo
  useEffect(() => {
    if (!aberto) return undefined;
    const fora = (ev) => { if (caixa.current && !caixa.current.contains(ev.target)) setAberto(false); };
    const esc = (ev) => { if (ev.key === "Escape") setAberto(false); };
    document.addEventListener("mousedown", fora);
    document.addEventListener("touchstart", fora);
    document.addEventListener("keydown", esc);
    return () => { document.removeEventListener("mousedown", fora); document.removeEventListener("touchstart", fora); document.removeEventListener("keydown", esc); };
  }, [aberto]);

  const carregar = useCallback(async () => {
    try { setItens(await listarNotificacoes()); } catch { /* sem login ou offline */ }
  }, []);

  useEffect(() => {
    carregar();
    const t = setInterval(carregar, 30000); // poll a cada 30s
    return () => clearInterval(t);
  }, [carregar]);

  const naoLidas = itens.filter((n) => !n.lida).length;

  const abrir = async (n) => {
    if (!n.lida) { try { await marcarNotificacaoLida(n.id); carregar(); } catch {} }
    // Notificação com link → navega (ex.: alerta de prazo abre o painel apontando pro relato).
    if (n.link) { setAberto(false); navigate(n.link); }
  };

  // 18/10/2026 (Nelson: "nem sempre a pessoa quer abrir o que está na notificação"): marca como lida sem abrir.
  const soMarcar = async (ev, n) => {
    ev.stopPropagation();
    setItens((v) => v.map((x) => (x.id === n.id ? { ...x, lida: true } : x)));
    try { await marcarNotificacaoLida(n.id); } catch {}
  };

  const marcarTodas = async () => {
    try { await marcarTodasNotificacoesLidas(); carregar(); } catch {}
  };

  return (
    <div className="relative" ref={caixa}>
      <button
        onClick={() => setAberto((v) => !v)}
        className="relative inline-flex h-9 w-9 items-center justify-center rounded-full hover:bg-white/15"
        aria-label={naoLidas > 0 ? `Notificações (${naoLidas} não lidas)` : "Notificações"}
        aria-haspopup="true"
        aria-expanded={aberto}
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M18 8a6 6 0 10-12 0c0 7-3 9-3 9h18s-3-2-3-9" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M13.7 21a2 2 0 01-3.4 0" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
        {naoLidas > 0 && (
          <span className="absolute -top-0.5 -right-0.5 h-4 min-w-4 px-1 rounded-full bg-orange-500 text-[10px] font-bold flex items-center justify-center">
            {naoLidas}
          </span>
        )}
      </button>

      {aberto && (
        <div className="absolute right-0 mt-2 w-80 max-h-[28rem] flex flex-col rounded-xl bg-white text-gray-800 shadow-xl border border-gray-200 z-50">
          <div className="px-4 py-3 border-b">
            <span className="font-semibold text-sm">Notificações</span>
          </div>
          <div className="flex-1 overflow-auto">
            {itens.length === 0 ? (
              <div className="px-4 py-6 text-sm text-gray-500 text-center">Sem notificações.</div>
            ) : (
              itens.map((n) => (
                <div key={n.id} className={`group flex items-start gap-2 border-b last:border-0 hover:bg-gray-50 ${n.lida ? "opacity-60" : ""}`}>
                  <button onClick={() => abrir(n)} className="flex-1 min-w-0 text-left px-4 py-3">
                    <div className="flex items-start gap-2">
                      {!n.lida && <span className="mt-1.5 h-2 w-2 rounded-full bg-orange-500 shrink-0" />}
                      <div>
                        <p className="text-sm">{n.texto}</p>
                        <p className="text-xs text-gray-400 mt-0.5">{new Date(n.criadoEm).toLocaleString("pt-BR")}</p>
                      </div>
                    </div>
                  </button>
                  {!n.lida && (
                    <button onClick={(ev) => soMarcar(ev, n)} title="Marcar como lida (sem abrir)"
                      className="shrink-0 mt-2.5 mr-2 rounded-full px-2 py-1 text-[11px] font-semibold text-gray-500 hover:bg-gray-200 hover:text-gray-800">✓ lida</button>
                  )}
                </div>
              ))
            )}
          </div>
          {/* rodapé fixo do popup (não no fim da lista): sempre à mão, mesmo com muitas notificações */}
          {itens.length > 0 && (
            <div className="border-t px-4 py-2.5 text-center">
              {naoLidas > 0
                ? <button onClick={marcarTodas} className="text-xs text-primary font-semibold hover:underline">Marcar todas como lidas ({naoLidas})</button>
                : <span className="text-xs text-gray-400">Tudo lido ✓</span>}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
